module.exports = __webpack_public_path__ + "static/img/contact.52bb0d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact.png
// module id = EJVn
// module chunks = 5